// -*- Mode: rjsx -*-
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Celebrate from './Celebrate.jsx';
import Option from './Option.jsx';

import { loadQueue, dismissEntity, EMPTY_ENTITY } from '..';

import { setCurrentRequest } from '../../request';
import { FHMaterialStyles, FHTheme } from '../../../ui';

// for the loading card...
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';

import LinearProgress from '@mui/material/LinearProgress';

const TIMEOUT = 100;


function FullScreenLoading(props) {
    const classes = FHMaterialStyles({ color: FHTheme.palette.primary.main });
    return (
        <div className={classes.loadingContainer}>            
          <div className={classes.loadingCard}>
            
            <CardContent className={classes.loadingContent}>
              <LinearProgress />
              <Typography style={{ margin: 32,
                                   marginTop: 48,
                                   fontSize: '2rem',
                                   textAlign: "center" }} variant={'h2'}>
                Get Ready!
              </Typography>
            </CardContent>
            
          </div>
        </div>
    );
    
}

function QueueAd(props) {
    return (
        <Card>

          
          <CardContent>
            <Typography color="textSecondary" variant="body2" gutterBottom>
              Queue Status: { props.status }
            </Typography>
            <p>
              This is your queue. It was generated specifically for you. We think this is the next thing you should work on.
            </p>
          </CardContent>
          
        </Card>
        
    );
}

function QueueNextItem(props) {
    console.log("qni: %o", props);
    const entity = props.entity;
    const request = useSelector(state => state.requests.byKey[entity.data] || {});
    return (<Card>
              <CardContent>
                <Typography color="textSecondary" variant="body2" gutterBottom>                
                  {request.title}
                </Typography>
              </CardContent>
            </Card>
           );
}

function QueueNext(props) {
    const items = useSelector( (state) => {
        return state.queue.entities.length > 1 ? state.queue.entities.slice(1) : [];
    });

    return (
        <>
          { items.map((i) =>  <QueueNextItem entity={i} />)  }
        </>
    );

}

function Queue(props) {
    const dispatch = useDispatch();
    
//    let [visible, setVisible] = useState(true);
//    let [direction, setDirection] = useState('left');
    
    const celebrate = useSelector( (state) => {
        return state.queue ? state.queue.celebrate : null;
    });

    const entity = useSelector( (state) => {
        return state.queue.entities.length ? state.queue.entities[0] : EMPTY_ENTITY;
    });
    
    const status = useSelector( (state) => state.queue.status );
    const [visible, setVisible] = useState(true);
    
    const direction = visible ? "left" : "right";
    
    let [id, setId] = useState(null);

    const dismiss = (entity) => {
        // console.log("dismiss: %o", entity);
        // console.log("dispatch: %o", dispatch);
        // console.log("dismissEntity: %o", dismissEntity);
        setVisible(false);
        dispatch(dismissEntity({ requestKey: entity.data }))
            .then((data) => {
                setTimeout(function() { setVisible(true); }, TIMEOUT);
                console.log("dismissed: %o", data);
            })
            .catch((data) => {
                console.error("WTF: %o", data);
            });
//        setVisible(false);        
    };
    
	useEffect(() => {
        console.log("id: %o, entity: %o", id, entity);
        
        dispatch(setCurrentRequest(null));
        

        if(status == 'init')
		    dispatch(loadQueue());
    }, []);
    
    if(['loading', 'init'].indexOf(status) !== -1) {
        return <FullScreenLoading />;
    }
    
    
    if(celebrate) {
        return <Celebrate data={celebrate} />;
    }

    else {
        return (

              <div>
                
                { entity.meta.id
                  ?
                  <Option entity={entity} dismiss={dismiss} visible={visible} direction={direction} />
                  :
                  <em>Nothing to see here...</em>
                }

                {/* <QueueAd status={status} /> */}
                <QueueNext />
              </div>

        );
    }
    
}

export default Queue;
